import { Link } from 'react-router';

const MinimalNavigationHeader = () => {
  return (
    <nav className="bg-primary sticky top-0 z-50 border-b border-white/10">
      <div className="mx-auto max-w-[105rem] px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 items-center justify-between">
          <Link to="/" prefetch="render" className="flex-shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="23"
              viewBox="0 0 172.786 28.054"
              className="h-6 w-auto"
            >
              <path
                d="M40.123,7.014V28.054h9.092V0H33.559V7.014ZM13.941,20.96c2.06,0,3.111-.842,3.111-2.043v-.081c0-1.2-1.01-2.043-3.071-2.043H9.213V20.96Zm-.606-9.941c2.019,0,2.989-.678,2.989-1.922V9.017c0-1.24-1.009-1.922-3.029-1.922H9.213v3.926ZM0,0H15.838c3.921,0,6.384.881,8.042,2.525a5.973,5.973,0,0,1,1.737,4.367v.081c0,3.325-2.02,5.371-5.05,6.412,3.635,1.042,5.98,2.966,5.98,6.814v.079c0,4.49-3.717,7.776-10.868,7.776H0ZM172.786,28.054,158.7,14.083v-.112L172.785,0H161.357L150.751,10.52h-2.536V0h-9.09V28.054h9.091V17.534h2.536l10.606,10.52ZM77.408,21.041V0h-9.09V28.054H89.53V21.041ZM104.683,0H95.591V28.054h9.091Zm25.352,16.131V0H113.773Zm0,11.923H113.773V11.923Z"
                fill="#ffffff"
              />
            </svg>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default MinimalNavigationHeader;
